(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabsComponents = document.querySelectorAll('.tabs-container');
    tabsComponents.forEach(function (component) {
      const tabsLinks = component.querySelectorAll('.tabs-link');

      tabsLinks.forEach(function (link) {
        link.addEventListener('click', function () {
          const targetTab = this.getAttribute('data-tab');
          tabsLinks.forEach((item) => {
            item.classList.remove('active');
          });
          link.classList.add('active');
          const tabContents = component.querySelectorAll('.tab-content');
          tabContents.forEach(function (content) {
            content.classList.remove('active');
          });

          const activeTab = component.querySelector(`#${targetTab}`);
          if (activeTab) {
            activeTab.classList.add('active');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature_carousel-2609"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-feature-carousel]';
    const instances = new WeakMap();

    function initialize(section) {
      if (instances.has(section)) return;
      const element = section.querySelector('.feature-carousel-2609__swiper');
      if (!element) return;

      const inset = () => {
        const isTablet = window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches;
        return (isTablet ? 48 : Math.max(24, (element.clientWidth - 1200) / 2)) - 8;
      };
      const previous = section.querySelector('.feature-carousel-2609__previous');
      const next = section.querySelector('.feature-carousel-2609__next');
      const slides = [...element.querySelectorAll('.feature-carousel-2609__slide')];
      const desktop = window.matchMedia('(min-width: 768px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let animations = [];
      const cancelAnimations = () => {
        animations.forEach((animation) => animation.cancel());
        animations = [];
      };
      const reserveContentHeight = () => {
        section.style.removeProperty('--feature-content-height');
        if (!desktop.matches || !element.clientWidth) return;
        const expanded = slides.filter((slide) => slide.classList.contains('is-expanded'));
        if (slides.length > 1) expanded.forEach((slide) => slide.classList.remove('is-expanded'));
        const height = Math.max(0, ...slides.map((slide) => {
          return slide.querySelector('.feature-carousel-2609__content')?.getBoundingClientRect().height || 0;
        }));
        section.style.setProperty('--feature-content-height', `${Math.ceil(height)}px`);
        expanded.forEach((slide) => slide.classList.add('is-expanded'));
      };
      const updateButtons = (swiper) => {
        if (previous) previous.disabled = swiper.isBeginning || swiper.isLocked;
        if (next) next.disabled = swiper.isEnd || swiper.isLocked;
      };
      const swiper = new Swiper(element, {
        init: false,
        slidesPerView: 'auto',
        slidesOffsetBefore: inset(),
        slidesOffsetAfter: inset(),
        speed: reducedMotion.matches ? 0 : 500,
        preventInteractionOnTransition: desktop.matches,
        resizeObserver: false,
        watchOverflow: false,
        navigation: { prevEl: previous, nextEl: next },
        on: {
          init: updateButtons,
          slideChange: updateButtons,
          reachBeginning: updateButtons,
          reachEnd: updateButtons,
          fromEdge: updateButtons,
          lock: updateButtons,
          unlock: updateButtons,
          beforeResize(instance) {
            cancelAnimations();
            instance.wrapperEl.dispatchEvent(new Event('transitionend'));
            instance.params.preventInteractionOnTransition = desktop.matches;
            instance.params.slidesOffsetBefore = inset();
            instance.params.slidesOffsetAfter = inset();
          },
          update: updateButtons,
          destroy: cancelAnimations,
        },
      });

      const slideTo = swiper.slideTo.bind(swiper);
      swiper.slideTo = (index = 0, speed = swiper.params.speed, ...args) => {
        if (swiper.destroyed || (swiper.animating && swiper.params.preventInteractionOnTransition)) return false;
        const target = Math.max(0, Math.min(Number(index), slides.length - 1));
        const widths = slides.map((slide) => slide.getBoundingClientRect().width);
        const previousEndOffset = parseFloat(getComputedStyle(swiper.wrapperEl).translate) || 0;
        cancelAnimations();
        reserveContentHeight();
        slides.forEach((slide, slideIndex) => slide.classList.toggle('is-expanded', slideIndex === target));

        if (desktop.matches) {
          // Measure the final layout before animating so Swiper uses the new snap positions.
          const finalWidths = slides.map((slide) => slide.getBoundingClientRect().width);
          // Keep Swiper's logical snap positions while aligning the final card to the right gutter.
          const endOffset = target === slides.length - 1 && slides.length > 1
            ? Math.max(0, element.clientWidth - 2 * inset() - finalWidths[target])
            : 0;
          swiper.wrapperEl.style.translate = `${endOffset}px 0px`;
          const totalWidth = finalWidths.reduce((total, width) => total + width, 0);
          const lastPosition = totalWidth - finalWidths[finalWidths.length - 1] - inset();
          swiper.params.slidesOffsetAfter = Math.max(0, lastPosition + element.clientWidth - Math.max(totalWidth, element.clientWidth));
          swiper.updateSlides();
          // Every card remains selectable, including when two cards fit inside the viewport.
          swiper.isLocked = slides.length < 2;
          swiper.allowSlideNext = !swiper.isLocked;
          swiper.allowSlidePrev = !swiper.isLocked;
          const duration = reducedMotion.matches ? 0 : speed;
          const result = slideTo(target, duration, ...args);
          if (duration > 0) {
            animations = slides.flatMap((slide, slideIndex) => {
              if (Math.abs(widths[slideIndex] - finalWidths[slideIndex]) < 0.1) return [];
              return [slide.animate(
                [{ width: `${widths[slideIndex]}px` }, { width: `${finalWidths[slideIndex]}px` }],
                { duration, easing: 'ease' },
              )];
            });
            if (Math.abs(previousEndOffset - endOffset) > 0.1) {
              animations.push(swiper.wrapperEl.animate(
                [{ translate: `${previousEndOffset}px 0px` }, { translate: `${endOffset}px 0px` }],
                { duration, easing: 'ease' },
              ));
            }
          }
          updateButtons(swiper);
          return result;
        }

        swiper.wrapperEl.style.removeProperty('translate');
        swiper.params.slidesOffsetAfter = inset();
        swiper.checkOverflow();
        return slideTo(target, speed, ...args);
      };
      instances.set(section, swiper);
      swiper.init();
      // Text reflow changes height during expansion; only width changes should reset the layout.
      const resizeObserver = new ResizeObserver(() => {
        if (!element.clientWidth || element.clientWidth === swiper.width) return;
        swiper.emit('beforeResize');
        swiper.emit('resize');
      });
      resizeObserver.observe(element);
      swiper.on('destroy', () => resizeObserver.disconnect());
      document.fonts.ready.then(async () => {
        await Promise.allSettled(animations.map((animation) => animation.finished));
        if (!swiper.destroyed && !animations.some((animation) => animation.playState === 'running')) reserveContentHeight();
      });
    }

    function initializeWithin(root) {
      if (root.matches?.(selector)) initialize(root);
      root.querySelectorAll(selector).forEach(initialize);
    }

    document.addEventListener('DOMContentLoaded', () => initializeWithin(document));
    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(selector).forEach((section) => {
        instances.get(section)?.destroy(true, true);
        instances.delete(section);
      });
    });
    document.addEventListener('shopify:block:select', (event) => {
      const section = event.target.closest(selector);
      if (!section) return;
      const slides = [...section.querySelectorAll('.feature-carousel-2609__slide')];
      const index = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
      if (index >= 0) instances.get(section)?.slideTo(index, 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navimow-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const subscribeForms = document.querySelectorAll(
      '.navimow-banner-subscribe-form',
    );
    const requestJson = function (url, options = {}) {
      const baseUrl = window.baseUrl;
      return fetch(baseUrl + url, {
        headers: {
          'wb-api-key': 'd1befa03c79ca0b84ecc488dea96bc68',
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        ...options,
      }).then((res) => res.json());
    };
    subscribeForms.forEach((form) => {
      form.action = '';
      const submitBtn = form.querySelector('button[type="submit"]');
      if (!submitBtn) return;

      let skipNextSubmitTracking = false;
      const trackSubscribeButtonClick = () => {
        try {
          const trackingData = form.querySelector('[data-banner-subscribe-tracking]')?.dataset || {};
          window.trackGA4Event?.({
            event_name: 'banner_button_click',
            event_parameters: {
              current_page: window.location.href,
              subheading: trackingData.subheading || '',
              heading: trackingData.heading || '',
              description: trackingData.description || '',
              button_name: trackingData.buttonName || '',
              link: '',
            },
          });
        } catch (error) {
          console.warn('[navimow-banner] Subscribe tracking failed.', error);
        }
      };

      submitBtn.addEventListener('click', () => {
        skipNextSubmitTracking = true;
        trackSubscribeButtonClick();
        window.setTimeout(() => {
          skipNextSubmitTracking = false;
        }, 0);
      });

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (skipNextSubmitTracking) {
          skipNextSubmitTracking = false;
        } else {
          trackSubscribeButtonClick();
        }
        form.classList.add('loading');
        submitBtn.disabled = true;

        const formData = new FormData(form);

        const site = window.site;

        window
          .getRecaptchaToken()
          .then((token) => {
            return requestJson(
              `/newOfficialWebsite/customer/addCustomerInfo?site=${site}`,
              {
                method: 'POST',
                body: JSON.stringify({
                  email: formData.get('contact[email]'),
                  tags: `${formData.get('contact[tags]')}`,
                  recaptchaToken: token,
                  emailMarketingConsent: {
                    marketingState: 'SUBSCRIBED',
                    marketingOptInLevel: 'SINGLE_OPT_IN',
                  },
                }),
              },
            );
          })

          .then((data) => {
            if (data.code === 200) {
              form.classList.add('success');
            } else {
              form.classList.add('error');
            }
            setTimeout(() => {
              form.classList.remove('success');
              form.classList.remove('error');
              form.reset();
            }, 3500);
          })
          .catch((error) => {
            form.classList.add('error');
          })
          .finally(() => {
            form.classList.remove('loading');
            submitBtn.disabled = false;
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navimow-float-button-group"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const scrollButtonGroups = Array.from(
      document.querySelectorAll('.navimow-float-button-group'),
      (section) => ({
        threshold: Number(section.dataset.scrollThreshold),
        buttons: section.querySelectorAll('.navimow-float-button-item.first-screen-invisible'),
        visible: false,
      }),
    ).filter((group) => group.buttons.length > 0);

    if (scrollButtonGroups.length === 0) return;

    // Observe the document origin instead of synchronously reading scrollY.
    const scrollOrigin = document.createElement('span');
    scrollOrigin.className = 'navimow-float-scroll-origin';
    scrollOrigin.setAttribute('aria-hidden', 'true');
    document.body.prepend(scrollOrigin);

    scrollButtonGroups.forEach((group) => {
      const threshold = Number.isFinite(group.threshold) ? group.threshold : 0;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.rootBounds) return;
          const visible = entry.boundingClientRect.top < entry.rootBounds.top;
          if (visible === group.visible) return;

          group.visible = visible;
          group.buttons.forEach((button) => {
            button.classList.toggle('first-screen-invisible', !visible);
          });
        });
      }, {
        rootMargin: `${threshold}px 0px 0px 0px`,
        threshold: 0,
      });

      observer.observe(scrollOrigin);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navimow-grid-draw"] && !Shopify.designMode) return;
  try {
    
  if (
    window.customElements &&
    !window.customElements.get('navimow-grid-draw-widget')
  ) {
    class NavimowGridDrawWidget extends HTMLElement {
      constructor() {
        super();
        this.prizes = [];
        this.isDrawing = false;
        this.activeIndex = -1;
        this.handleDrawButtonClick = this.handleDrawButtonClick.bind(this);
      }

      connectedCallback() {
        this.sectionEl = this.closest('.navimow-grid-draw');
        this.prizeGridEl = this.querySelector('[data-grid-prizes]');
        this.drawButtonEl = this.querySelector('[data-draw-button]');

        if (this.drawButtonEl) {
          this.drawButtonEl.addEventListener(
            'click',
            this.handleDrawButtonClick,
          );
        }

        this.renderPrizeItems(this.prizes);
      }

      disconnectedCallback() {
        if (this.drawButtonEl) {
          this.drawButtonEl.removeEventListener(
            'click',
            this.handleDrawButtonClick,
          );
        }
      }

      escapeHtml(value) {
        return String(value == null ? '' : value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      getGridColumns(count) {
        return count <= 4 ? 2 : 3;
      }

      getDefaultGridCount() {
        var count = Number(this.dataset.defaultGridCount || 4);
        return [4, 6, 9].includes(count) ? count : 4;
      }

      getClockwiseVisualIndexes(count) {
        if (count === 4) return [0, 1, 3, 2];
        if (count === 6) return [0, 1, 2, 5, 4, 3];
        return Array.from({ length: count }, function (_, index) {
          return index;
        });
      }

      renderPrizeItems(prizes) {
        this.prizes = Array.isArray(prizes) ? prizes : [];

        if (this.sectionEl) {
          this.sectionEl.navimowGridDraw = this.sectionEl.navimowGridDraw || {};
          this.sectionEl.navimowGridDraw.prizes = this.prizes;
          if (
            typeof this.sectionEl.navimowGridDraw.syncDrawButtonState ===
            'function'
          ) {
            this.sectionEl.navimowGridDraw.syncDrawButtonState();
          }
        }

        if (!this.prizeGridEl) return;

        var count = this.prizes.length || this.getDefaultGridCount();
        var cols = this.getGridColumns(count);
        var rows = Math.ceil(count / cols);

        this.prizeGridEl.style.setProperty('--grid-cols', cols);
        this.prizeGridEl.style.setProperty('--grid-rows', rows);
        this.prizeGridEl.setAttribute('data-grid-count', count);

        var items = this.prizes.length
          ? this.prizes
          : Array.from({ length: count }, function () {
              return {};
            });
        var visualIndexes = this.getClockwiseVisualIndexes(count);

        this.prizeGridEl.innerHTML = visualIndexes
          .map(
            function (sourceIndex) {
              var prize = items[sourceIndex] || {};
              var imageUrl = prize && prize.imageUrl ? prize.imageUrl : '';
              var title =
                prize && prize.externalTitle ? prize.externalTitle : '';

              return (
                '<div class="grid-draw-cell" data-prize-index="' +
                sourceIndex +
                '">' +
                '<div class="grid-draw-cell-image">' +
                (imageUrl
                  ? '<img src="' +
                    this.escapeHtml(imageUrl) +
                    '" alt="' +
                    this.escapeHtml(title) +
                    '" loading="lazy">'
                  : '') +
                '</div>' +
                '<div class="grid-draw-cell-title">' +
                this.escapeHtml(title) +
                '</div>' +
                '</div>'
              );
            }.bind(this),
          )
          .join('');
      }

      setActiveIndex(index) {
        if (!this.prizeGridEl) return;

        this.prizeGridEl
          .querySelectorAll('.grid-draw-cell')
          .forEach(function (cell) {
            cell.classList.toggle(
              'is-active',
              Number(cell.dataset.prizeIndex) === index,
            );
          });
        this.activeIndex = index;
      }

      getPrizeIndexByRecord(lotteryRecord) {
        var state = this.sectionEl.navimowGridDraw || {};
        var prizes = Array.isArray(state.prizes) ? state.prizes : [];
        if (!prizes.length || !lotteryRecord) return -1;

        var targetPrizeId =
          lotteryRecord.id != null ? String(lotteryRecord.id) : '';
        if (!targetPrizeId) return -1;

        return prizes.findIndex(function (prize) {
          return (
            prize && prize.id != null && String(prize.id) === targetPrizeId
          );
        });
      }

      requestDrawResult() {
        var state = this.sectionEl.navimowGridDraw || {};
        var latestEmail = state.latestEmail;
        var deviceId = '';

        if (typeof state.clearErrors === 'function') {
          state.clearErrors();
        }

        return window
          .getDeviceFingerprint()
          .then((fp) => {
            deviceId = fp;
            return window.getRecaptchaToken();
          })
          .then((token) => {
            return window.requestJson('/newOfficialWebsite/lottery/draw-v2', {
              method: 'POST',
              body: JSON.stringify({
                email: latestEmail,
                recaptchaToken: token,
                activityId: state.activityId,
                pageUrl: window.location.href,
                deviceId,
                tags: state.getDrawTags(),
              }),
            });
          })
          .then(
            function (res) {
              if (!res || res.code !== 200) {
                var errorMessage =
                  (res && res.message) ||
                  'Server error. Please try again later.';
                if (typeof state.showError === 'function') {
                  state.showError('api', errorMessage);
                }
                var displayedError = new Error(errorMessage);
                displayedError.isDisplayed = true;
                throw displayedError;
              }

              var drawData =
                res.data && Array.isArray(res.data)
                  ? res.data[0]
                  : res.data || {};
              var prizeIndex = this.getPrizeIndexByRecord(drawData);
              if (prizeIndex < 0) {
                throw new Error('Prize record not found in prize list');
              }

              if (typeof state.setLotteryCount === 'function') {
                var nextLotteryCount = Number(drawData.lotteryCount);
                if (!Number.isFinite(nextLotteryCount)) {
                  nextLotteryCount = Math.max(
                    Number(state.lotteryCount || 0) - 1,
                    0,
                  );
                }
                state.setLotteryCount(nextLotteryCount);
              }

              state.latestLotteryRecord = drawData;
              if (Array.isArray(state.resultList)) {
                if (!drawData.time && !drawData.createTime) {
                  var now = new Date();
                  var year = now.getFullYear();
                  var month = String(now.getMonth() + 1).padStart(2, '0');
                  var day = String(now.getDate()).padStart(2, '0');
                  var hours = String(now.getHours()).padStart(2, '0');
                  var minutes = String(now.getMinutes()).padStart(2, '0');
                  drawData.time =
                    year +
                    '-' +
                    month +
                    '-' +
                    day +
                    ' ' +
                    hours +
                    ':' +
                    minutes;
                }
                state.resultList.unshift(drawData);
                state.resultList = state.resultList.slice(0, 10);
              }

              return prizeIndex;
            }.bind(this),
          )
          .catch(function (error) {
            if (!error || !error.isDisplayed) {
              if (typeof state.showError === 'function') {
                state.showError(
                  'api',
                  (error && error.message) ||
                    'Server error. Please try again later.',
                );
              }
            }
            throw error;
          });
      }

      startDraw(fetchResult) {
        if (this.isDrawing || !this.prizes.length) return null;

        this.isDrawing = true;
        var state = this.sectionEl.navimowGridDraw || {};
        state.isDrawing = true;
        if (typeof state.syncDrawButtonState === 'function') {
          state.syncDrawButtonState();
        }

        var prizeCount = this.prizes.length;
        var currentIndex = this.activeIndex;
        var steps = 0;
        var minSteps = prizeCount * 3 + 6;
        var resultReady = false;
        var resultIndex = -1;
        var timer = null;

        var promise = new Promise(
          function (resolve, reject) {
            fetchResult()
              .then(function (index) {
                resultReady = true;
                resultIndex = index;
              })
              .catch(
                function (error) {
                  window.clearTimeout(timer);
                  this.isDrawing = false;
                  state.isDrawing = false;
                  if (typeof state.syncDrawButtonState === 'function') {
                    state.syncDrawButtonState();
                  }
                  reject(error);
                }.bind(this),
              );

            var tick = function () {
              currentIndex = (currentIndex + 1) % prizeCount;
              steps += 1;
              this.setActiveIndex(currentIndex);

              if (
                resultReady &&
                steps >= minSteps &&
                currentIndex === resultIndex
              ) {
                this.isDrawing = false;
                state.isDrawing = false;
                if (typeof state.syncDrawButtonState === 'function') {
                  state.syncDrawButtonState();
                }
                resolve(resultIndex);
                return;
              }

              var delay = Math.min(70 + steps * 8, resultReady ? 240 : 120);
              timer = window.setTimeout(tick, delay);
            }.bind(this);

            tick();
          }.bind(this),
        );

        return { promise: promise };
      }

      handleDrawButtonClick() {
        var state = this.sectionEl.navimowGridDraw || {};
        if (Number(state.lotteryCount || 0) <= 0 || !state.latestEmail) return;
        if (!Array.isArray(state.prizes) || !state.prizes.length) return;

        var ctrl = this.startDraw(this.requestDrawResult.bind(this));
        if (!ctrl) return;

        ctrl.promise
          .then(
            function () {
              if (typeof state.openResultModal === 'function') {
                state.openResultModal(state.latestLotteryRecord);
              }
              if (typeof state.getRecord === 'function') {
                state.getRecord(state.latestEmail);
              }
            }.bind(this),
          )
          .catch(function (error) {
            console.error('Grid draw failed:', error);
          });
      }
    }

    customElements.define('navimow-grid-draw-widget', NavimowGridDrawWidget);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navimow-prize-wheel"] && !Shopify.designMode) return;
  try {
    
  if (
    window.customElements &&
    !window.customElements.get('navimow-prize-wheel-widget')
  ) {
    class NavimowPrizeWheelWidget extends HTMLElement {
      constructor() {
        super();
        this.shadowRootRef =
          this.shadowRoot ||
          this.attachShadow({ mode: 'open', delegatesFocus: true });
        this.currentRotation = 0;
        this.isSpinning = false;
        this.isInitialized = false;
        this.prizes = [];
        this.cssWidth = 0;
        this.cssHeight = 0;
        this.pixelRatio = 1;
        this.ctx = null;
        this.backgroundImage = null;
        this.imagePromises = new Map();
        this.loadedImages = new Map();
        this.resizeObserver = null;
        this.staticWheelCanvas = document.createElement('canvas');
        this.staticWheelCtx = this.staticWheelCanvas.getContext('2d');
        this.handlePrizeButtonClick = this.handlePrizeButtonClick.bind(this);
        this.handleWindowResize = this.handleWindowResize.bind(this);
      }

      connectedCallback() {
        if (!this.shadowRootRef.hasChildNodes()) {
          this.shadowRootRef.innerHTML =
            '<style>:host{display:block;isolation:isolate;contain:paint;}::slotted(*){box-sizing:border-box;}</style><slot></slot>';
        }

        if (this.isInitialized) return;

        this.sectionEl = this.closest('.navimow-prize-wheel');
        this.stageEl = this.querySelector('.prize-wheel-stage');
        this.canvasEl = this.querySelector('.prize-wheel-canvas');
        this.prizeButton = this.querySelector('.prize-button');

        if (!this.sectionEl || !this.stageEl || !this.canvasEl) {
          return;
        }

        this.ctx = this.canvasEl.getContext('2d', {
          alpha: true,
        });
        if (!this.ctx) return;

        if (this.prizeButton) {
          this.prizeButton.addEventListener(
            'click',
            this.handlePrizeButtonClick,
          );
        }
        if (window.ResizeObserver) {
          this.resizeObserver = new window.ResizeObserver(
            this.handleWindowResize,
          );
          this.resizeObserver.observe(this.stageEl);
        } else {
          window.addEventListener('resize', this.handleWindowResize);
        }

        this.isInitialized = true;
        this.updateCanvasSize();
        this.loadBackgroundImage();
      }

      disconnectedCallback() {
        if (this.prizeButton) {
          this.prizeButton.removeEventListener(
            'click',
            this.handlePrizeButtonClick,
          );
        }
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
          this.resizeObserver = null;
        } else {
          window.removeEventListener('resize', this.handleWindowResize);
        }
        this.isInitialized = false;
      }

      renderPrizeItems(prizes) {
        this.prizes = Array.isArray(prizes) ? prizes : [];

        this.sectionEl.navimowPrizeWheel =
          this.sectionEl.navimowPrizeWheel || {};
        this.sectionEl.navimowPrizeWheel.prizes = this.prizes;
        if (
          typeof this.sectionEl.navimowPrizeWheel.syncPrizeButtonState ===
          'function'
        ) {
          this.sectionEl.navimowPrizeWheel.syncPrizeButtonState();
        }

        this.prizes.forEach(
          function (prize) {
            if (prize && prize.imageUrl) {
              this.loadImage(prize.imageUrl).then(
                function () {
                  this.rebuildStaticWheel();
                  this.drawWheel(this.currentRotation);
                }.bind(this),
              );
            }
          }.bind(this),
        );

        this.rebuildStaticWheel();
        this.drawWheel(this.currentRotation);
      }

      getPrizeCount() {
        return this.prizes.length || 4;
      }

      handleWindowResize() {
        this.updateCanvasSize();
      }

      hermite(p, p0, p1, v0, v1) {
        var p2 = p * p;
        var p3 = p2 * p;
        return (
          (2 * p3 - 3 * p2 + 1) * p0 +
          (p3 - 2 * p2 + p) * v0 +
          (-2 * p3 + 3 * p2) * p1 +
          (p3 - p2) * v1
        );
      }

      loadImage(src) {
        if (!src) return Promise.resolve(null);
        if (this.imagePromises.has(src)) {
          return this.imagePromises.get(src);
        }

        var promise = new Promise(
          function (resolve) {
            var isResolved = false;
            var image = new Image();
            image.decoding = 'async';
            image.crossOrigin = 'anonymous';

            var finalize = function (loadedImage) {
              if (isResolved) return;
              isResolved = true;
              this.loadedImages.set(src, loadedImage);
              resolve(loadedImage);
            }.bind(this);

            image.onload = function () {
              finalize(image);
            };
            image.onerror = function () {
              finalize(null);
            };
            image.src = src;

            if (image.complete && image.naturalWidth > 0) {
              finalize(image);
            }
          }.bind(this),
        );

        this.imagePromises.set(src, promise);
        return promise;
      }

      loadBackgroundImage() {
        var backgroundUrl = this.dataset.wheelBackground || '';
        if (!backgroundUrl) {
          this.backgroundImage = null;
          this.drawWheel(this.currentRotation);
          return Promise.resolve(null);
        }

        return this.loadImage(backgroundUrl).then(
          function (image) {
            this.backgroundImage = image;
            this.rebuildStaticWheel();
            this.drawWheel(this.currentRotation);
            return image;
          }.bind(this),
        );
      }

      updateCanvasSize() {
        if (
          !this.stageEl ||
          !this.canvasEl ||
          !this.ctx ||
          !this.staticWheelCanvas ||
          !this.staticWheelCtx
        ) {
          return;
        }

        var rect = this.stageEl.getBoundingClientRect();
        if (!rect.width || !rect.height) return;

        var cssWidth = Math.round(rect.width);
        var cssHeight = Math.round(rect.height);
        var pixelRatio = Math.max(1, Math.min(window.devicePixelRatio || 1, 3));
        var bitmapWidth = Math.max(1, Math.round(cssWidth * pixelRatio));
        var bitmapHeight = Math.max(1, Math.round(cssHeight * pixelRatio));

        if (
          this.canvasEl.width !== bitmapWidth ||
          this.canvasEl.height !== bitmapHeight
        ) {
          this.canvasEl.width = bitmapWidth;
          this.canvasEl.height = bitmapHeight;
        }
        if (
          this.staticWheelCanvas.width !== bitmapWidth ||
          this.staticWheelCanvas.height !== bitmapHeight
        ) {
          this.staticWheelCanvas.width = bitmapWidth;
          this.staticWheelCanvas.height = bitmapHeight;
        }

        this.canvasEl.style.width = cssWidth + 'px';
        this.canvasEl.style.height = cssHeight + 'px';
        this.cssWidth = cssWidth;
        this.cssHeight = cssHeight;
        this.pixelRatio = pixelRatio;

        this.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        this.ctx.imageSmoothingEnabled = true;
        if ('imageSmoothingQuality' in this.ctx) {
          this.ctx.imageSmoothingQuality = 'high';
        }

        this.staticWheelCtx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        this.staticWheelCtx.imageSmoothingEnabled = true;
        if ('imageSmoothingQuality' in this.staticWheelCtx) {
          this.staticWheelCtx.imageSmoothingQuality = 'high';
        }

        this.rebuildStaticWheel();
        this.drawWheel(this.currentRotation);
      }

      rebuildStaticWheel() {
        if (
          !this.staticWheelCtx ||
          !this.staticWheelCanvas ||
          !this.cssWidth ||
          !this.cssHeight
        ) {
          return;
        }

        var ctx = this.staticWheelCtx;
        var diameter = Math.min(this.cssWidth, this.cssHeight);
        var radius = diameter / 2;
        var centerX = this.cssWidth / 2;
        var centerY = this.cssHeight / 2;

        ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
        ctx.clearRect(0, 0, this.cssWidth, this.cssHeight);

        ctx.save();
        ctx.translate(centerX, centerY);
        ctx.beginPath();
        ctx.arc(0, 0, radius, 0, Math.PI * 2);
        ctx.closePath();
        ctx.clip();
        this.drawWheelBase(ctx, radius);
        this.drawWheelPrizes(ctx, radius, diameter);
        ctx.restore();

        ctx.save();
        ctx.translate(centerX, centerY);
        ctx.beginPath();
        ctx.arc(0, 0, radius - 0.75, 0, Math.PI * 2);
        ctx.strokeStyle = 'rgba(0, 0, 0, 0.06)';
        ctx.lineWidth = 1.5;
        ctx.stroke();
        ctx.restore();
      }

      drawWheel(angle) {
        if (
          !this.ctx ||
          !this.cssWidth ||
          !this.cssHeight ||
          !this.staticWheelCanvas
        ) {
          return;
        }

        var ctx = this.ctx;
        var diameter = Math.min(this.cssWidth, this.cssHeight);
        var radius = diameter / 2;
        var centerX = this.cssWidth / 2;
        var centerY = this.cssHeight / 2;
        var normalizedAngle = ((angle % 360) + 360) % 360;

        ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
        ctx.clearRect(0, 0, this.cssWidth, this.cssHeight);

        ctx.save();
        ctx.translate(centerX, centerY);
        ctx.beginPath();
        ctx.arc(0, 0, radius, 0, Math.PI * 2);
        ctx.closePath();
        ctx.clip();
        ctx.rotate((normalizedAngle * Math.PI) / 180);
        ctx.drawImage(
          this.staticWheelCanvas,
          -centerX,
          -centerY,
          this.cssWidth,
          this.cssHeight,
        );
        ctx.restore();
      }

      drawWheelBase(ctx, radius) {
        if (this.backgroundImage && this.backgroundImage.naturalWidth > 0) {
          var coverScale = Math.max(
            (radius * 2) / this.backgroundImage.naturalWidth,
            (radius * 2) / this.backgroundImage.naturalHeight,
          );
          var drawWidth = this.backgroundImage.naturalWidth * coverScale;
          var drawHeight = this.backgroundImage.naturalHeight * coverScale;

          ctx.drawImage(
            this.backgroundImage,
            -drawWidth / 2,
            -drawHeight / 2,
            drawWidth,
            drawHeight,
          );
        } else {
          ctx.fillStyle = '#E5E7EB';
          ctx.fillRect(-radius, -radius, radius * 2, radius * 2);
        }
      }

      drawWheelPrizes(ctx, radius, diameter) {
        if (!this.prizes.length) return;

        var segmentAngle = (Math.PI * 2) / this.prizes.length;
        this.prizes.forEach(
          function (prize, index) {
            ctx.save();
            ctx.rotate(segmentAngle * index);
            this.drawPrizeAtTop(ctx, prize, radius, diameter);
            ctx.restore();
          }.bind(this),
        );
      }

      drawPrizeAtTop(ctx, prize, radius, diameter) {
        var image =
          prize && prize.imageUrl
            ? this.loadedImages.get(prize.imageUrl)
            : null;
        var title =
          prize && prize.externalTitle ? String(prize.externalTitle) : '';
        var imageSize = Math.min(diameter * 0.16, 74);
        imageSize = Math.max(imageSize, 44);
        var itemWidth = diameter * 0.3;
        var radialOffset = radius * 0.5;
        var fontSize = Math.max(11, Math.round(diameter * 0.026));
        var lineHeight = fontSize * 1.28;
        var lines = this.getWrappedLines(title, itemWidth, fontSize, 2);
        var hasImage = Boolean(image && image.naturalWidth > 0);
        var textHeight = lines.length ? lines.length * lineHeight : 0;
        var gap = hasImage && lines.length ? Math.max(1, diameter * 0.004) : 0;
        var contentHeight = textHeight + (hasImage ? imageSize : 0) + gap;
        var startY = -contentHeight / 2;

        ctx.save();
        ctx.translate(0, -radialOffset);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'top';
        ctx.fillStyle = '#161616';
        ctx.font =
          '600 ' +
          fontSize +
          'px system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

        lines.forEach(function (line, lineIndex) {
          ctx.fillText(line, 0, startY + lineIndex * lineHeight);
        });

        if (hasImage) {
          var imageTop = startY + textHeight + gap;
          this.drawContainedImage(
            ctx,
            image,
            -imageSize / 2,
            imageTop,
            imageSize,
            imageSize,
          );
        }

        ctx.restore();
      }

      getWrappedLines(text, maxWidth, fontSize, maxLines) {
        if (!text) return [];
        if (!this.ctx) return [text];

        var ctx = this.ctx;
        ctx.save();
        ctx.font =
          '600 ' +
          fontSize +
          'px system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

        var tokens = text.includes(' ')
          ? text.split(/\s+/).filter(Boolean)
          : text.split('');
        if (!tokens.length) {
          ctx.restore();
          return [];
        }

        var lines = [];
        var currentLine = '';

        tokens.forEach(function (token) {
          var candidate = currentLine
            ? text.includes(' ')
              ? currentLine + ' ' + token
              : currentLine + token
            : token;
          if (ctx.measureText(candidate).width <= maxWidth || !currentLine) {
            currentLine = candidate;
            return;
          }

          lines.push(currentLine);
          currentLine = token;
        });

        if (currentLine) {
          lines.push(currentLine);
        }

        if (lines.length > maxLines) {
          lines = lines.slice(0, maxLines);
          var lastLine = lines[maxLines - 1];
          while (
            lastLine.length > 1 &&
            ctx.measureText(lastLine + '…').width > maxWidth
          ) {
            lastLine = lastLine.slice(0, -1);
          }
          lines[maxLines - 1] = lastLine + '…';
        }

        ctx.restore();
        return lines;
      }

      drawContainedImage(ctx, image, x, y, width, height) {
        var scale = Math.min(
          width / image.naturalWidth,
          height / image.naturalHeight,
        );
        var drawWidth = image.naturalWidth * scale;
        var drawHeight = image.naturalHeight * scale;
        var offsetX = x + (width - drawWidth) / 2;
        var offsetY = y + (height - drawHeight) / 2;

        ctx.drawImage(image, offsetX, offsetY, drawWidth, drawHeight);
      }

      getPrizeIndexByRecord(lotteryRecord) {
        var state = this.sectionEl.navimowPrizeWheel || {};
        var prizes = Array.isArray(state.prizes) ? state.prizes : [];
        if (!prizes.length || !lotteryRecord) return -1;

        var targetPrizeId =
          lotteryRecord.id != null ? String(lotteryRecord.id) : '';
        if (!targetPrizeId) return -1;

        return prizes.findIndex(function (prize) {
          return (
            prize && prize.id != null && String(prize.id) === targetPrizeId
          );
        });
      }

      requestDrawResult() {
        var state = this.sectionEl.navimowPrizeWheel || {};
        var latestEmail = state.latestEmail;
        if (typeof state.clearErrors === 'function') {
          state.clearErrors();
        }

        const site = window.site || window.getSite();
        const baseUrl = window.baseUrl;
        let deviceId = '';
        return window
          .getDeviceFingerprint()
          .then((fp) => {
            deviceId = fp;
            return window.getRecaptchaToken();
          })
          .then((token) => {
            return window.requestJson('/newOfficialWebsite/lottery/draw-v2', {
              method: 'POST',
              body: JSON.stringify({
                email: latestEmail,
                recaptchaToken: token,
                activityId: state.activityId,
                pageUrl: window.location.href,
                deviceId,
                tags: state.getDrawTags(),
              }),
            });
          })
          .then(
            function (res) {
              if (!res || res.code !== 200) {
                var errorMessage =
                  (res && res.message) ||
                  'Server error. Please try again later.';
                if (typeof state.showError === 'function') {
                  state.showError('api', errorMessage);
                }
                var displayedError = new Error(errorMessage);
                displayedError.isDisplayed = true;
                throw displayedError;
              }

              var drawData =
                res.data && Array.isArray(res.data)
                  ? res.data[0]
                  : res.data || {};
              var prizeIndex = this.getPrizeIndexByRecord(drawData);

              if (prizeIndex < 0) {
                throw new Error('Prize record not found in prize list');
              }

              if (typeof state.setLotteryCount === 'function') {
                var nextLotteryCount = Number(drawData.lotteryCount);
                if (!Number.isFinite(nextLotteryCount)) {
                  nextLotteryCount = Math.max(
                    Number(state.lotteryCount || 0) - 1,
                    0,
                  );
                }
                state.setLotteryCount(nextLotteryCount);
              }
              state.latestLotteryRecord = drawData;
              if (Array.isArray(state.resultList)) {
                if (!drawData.time) {
                  var now = new Date();
                  var year = now.getFullYear();
                  var month = String(now.getMonth() + 1).padStart(2, '0');
                  var day = String(now.getDate()).padStart(2, '0');
                  var hours = String(now.getHours()).padStart(2, '0');
                  var minutes = String(now.getMinutes()).padStart(2, '0');
                  drawData.time =
                    year +
                    '-' +
                    month +
                    '-' +
                    day +
                    ' ' +
                    hours +
                    ':' +
                    minutes;
                }
                state.resultList.unshift(drawData);
                state.resultList = state.resultList.slice(0, 10);
              }

              return prizeIndex;
            }.bind(this),
          )
          .catch(function (error) {
            if (!error || !error.isDisplayed) {
              if (typeof state.showError === 'function') {
                state.showError(
                  'api',
                  (error && error.message) ||
                    'Server error. Please try again later.',
                );
              }
            }
            throw error;
          });
      }

      startSpin(fetchResult, options) {
        if (this.isSpinning) return null;
        this.isSpinning = true;

        var opts = Object.assign(
          {},
          {
            accelTime: 1200,
            decelTime: 2800,
            decelRounds: 3,
            accelSharpness: 1.5,
            decelSharpness: 1.5,
            cruiseDegsPerMs: 2,
            pointerAngleOffset: 0,
            settleAmplitude: 6,
            settleDuration: 600,
            settleFreq: 3,
          },
          options || {},
        );
        var accelTime = opts.accelTime;
        var decelTime = opts.decelTime;
        var decelRounds = opts.decelRounds;
        var accelSharpness = opts.accelSharpness;
        var cruiseDegsPerMs = opts.cruiseDegsPerMs;
        var pointerAngleOffset = opts.pointerAngleOffset;
        var settleAmplitude = opts.settleAmplitude;
        var settleDuration = opts.settleDuration;
        var settleFreq = opts.settleFreq;

        var accelDistance = 0.5 * cruiseDegsPerMs * accelTime;
        var accelStartAngle = this.currentRotation;

        var phase = 'accel';
        var startTime = null;

        var cruiseStartTime = null;
        var cruiseStartAngle = 0;

        var decelStartTime = null;
        var decelStartAngle = 0;
        var decelTargetAngle = 0;
        var decelDelta = 0;

        var settleStartTime = null;
        var settleBaseAngle = 0;

        var targetIndex = null;
        var resolvePromise = null;
        var rejectPromise = null;
        var promise = new Promise(function (resolve, reject) {
          resolvePromise = resolve;
          rejectPromise = reject;
        });

        var resultReady = false;
        var resultIndex = null;
        var fetchStarted = false;

        var beginFetch = function () {
          if (fetchStarted) return;
          fetchStarted = true;

          fetchResult()
            .then(function (idx) {
              resultIndex = idx;
              resultReady = true;
            })
            .catch(
              function (error) {
                phase = 'done';
                this.isSpinning = false;
                if (typeof rejectPromise === 'function') {
                  rejectPromise(error);
                }
              }.bind(this),
            );
        }.bind(this);

        var beginDecel = function (timestamp) {
          phase = 'decel';
          targetIndex = resultIndex;
          decelStartTime = timestamp;
          decelStartAngle = this.currentRotation;

          var naturalDistance = 0.5 * cruiseDegsPerMs * decelTime;

          var segmentAngle = 360 / this.getPrizeCount();
          var prizeAngle =
            (pointerAngleOffset - targetIndex * segmentAngle + 360) % 360;

          var rawTarget = this.currentRotation + naturalDistance;
          var remainder = rawTarget % 360;
          var forward = (prizeAngle - remainder + 360) % 360;
          decelDelta = naturalDistance + decelRounds * 360 + forward;
          if (decelDelta < naturalDistance * 0.8) {
            decelDelta += 360;
          }
          decelTargetAngle = decelStartAngle + decelDelta;
        }.bind(this);

        var animate = function (timestamp) {
          if (!startTime) startTime = timestamp;

          if (phase === 'accel') {
            var t = Math.min((timestamp - startTime) / accelTime, 1);
            var angle =
              accelStartAngle +
              this.hermite(
                t,
                0,
                accelDistance,
                0,
                cruiseDegsPerMs * accelTime * (1 / accelSharpness),
              );
            this.drawWheel(angle);
            this.currentRotation = angle;

            if (t >= 1) {
              phase = 'cruise';
              cruiseStartTime = timestamp;
              cruiseStartAngle = accelStartAngle + accelDistance;
              this.currentRotation = cruiseStartAngle;
              beginFetch();
            }
            requestAnimationFrame(animate);
          } else if (phase === 'cruise') {
            var cruiseElapsed = timestamp - cruiseStartTime;
            var angle = cruiseStartAngle + cruiseDegsPerMs * cruiseElapsed;
            this.drawWheel(angle);
            this.currentRotation = angle;

            if (resultReady) {
              beginDecel(timestamp);
            }
            requestAnimationFrame(animate);
          } else if (phase === 'decel') {
            var dt = Math.min((timestamp - decelStartTime) / decelTime, 1);
            var pos = this.hermite(
              dt,
              0,
              decelDelta,
              cruiseDegsPerMs * decelTime,
              0,
            );
            var angle = decelStartAngle + pos;
            this.drawWheel(angle);
            this.currentRotation = angle;

            if (dt >= 1) {
              phase = 'settle';
              settleStartTime = timestamp;
              settleBaseAngle = decelTargetAngle;
              this.currentRotation = settleBaseAngle;
            }
            requestAnimationFrame(animate);
          } else if (phase === 'settle') {
            var st = (timestamp - settleStartTime) / settleDuration;
            if (st >= 1) {
              this.drawWheel(settleBaseAngle);
              this.currentRotation = settleBaseAngle;
              this.isSpinning = false;
              phase = 'done';
              resolvePromise(targetIndex);
              return;
            }
            var decay = Math.exp(-5 * st);
            var wobble =
              settleAmplitude * decay * Math.sin(st * settleFreq * Math.PI * 2);
            this.drawWheel(settleBaseAngle + wobble);
            requestAnimationFrame(animate);
          }
        }.bind(this);

        requestAnimationFrame(animate);

        return { promise: promise };
      }

      handlePrizeButtonClick() {
        var state = this.sectionEl.navimowPrizeWheel || {};
        if (Number(state.lotteryCount || 0) <= 0 || !state.latestEmail) return;
        if (!Array.isArray(state.prizes) || !state.prizes.length) return;

        var ctrl = this.startSpin(this.requestDrawResult.bind(this));
        if (!ctrl) return;

        ctrl.promise
          .then(function (index) {
            console.log('Landed on prize index:', index);
            if (typeof state.openResultModal === 'function') {
              state.openResultModal(state.latestLotteryRecord);
              state.getRecord(state.latestEmail);
            }
          })
          .catch(function (error) {
            console.error('Prize draw failed:', error);
          });
      }
    }

    customElements.define(
      'navimow-prize-wheel-widget',
      NavimowPrizeWheelWidget,
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-card-tiling"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const SERVER_ERROR_MESSAGE = 'Server error. Please try again later.';
    const requestCache = window.__productCardTilingRequestCache || new Map();
    window.__productCardTilingRequestCache = requestCache;

    const escapeHtml = (value = '') =>
      String(value).replace(
        /[&<>'"]/g,
        (character) =>
          ({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            "'": '&#39;',
            '"': '&quot;',
          }[character]),
      );

    const safeUrl = (value, fallback = '#') => {
      const url = String(value || '').trim();
      return /^(https?:\/\/|\/|#)/i.test(url) ? url : fallback;
    };

    const variantIdFromGid = (value) =>
      String(value || '')
        .split('/')
        .pop()
        .replace(/\D/g, '');

    const priceToMinorUnits = (value) => {
      if (typeof value === 'number')
        return Number.isFinite(value) ? Math.round(value * 100) : null;

      const price = String(value || '')
        .replace(/\s/g, '')
        .replace(/[^\d.,-]/g, '');
      if (!price || !/\d/.test(price)) return null;

      const lastDot = price.lastIndexOf('.');
      const lastComma = price.lastIndexOf(',');
      const decimalIndex = Math.max(lastDot, lastComma);
      const decimalLength =
        decimalIndex >= 0 ? price.length - decimalIndex - 1 : 0;

      if (decimalIndex >= 0 && decimalLength > 0 && decimalLength <= 2) {
        const whole = price.slice(0, decimalIndex).replace(/\D/g, '') || '0';
        const fraction = price
          .slice(decimalIndex + 1)
          .replace(/\D/g, '')
          .padEnd(2, '0')
          .slice(0, 2);
        return Number(whole) * 100 + Number(fraction);
      }

      const whole = price.replace(/\D/g, '');
      return whole ? Number(whole) * 100 : null;
    };

    const getCollectionData = (productId, country) => {
      const normalizedProductId = String(productId || '').trim();
      const normalizedCountry = String(country || 'US')
        .trim()
        .toUpperCase();

      if (!normalizedProductId) {
        return Promise.reject(
          new Error('Please configure a Product ID for this section.'),
        );
      }

      const cacheKey = `${normalizedProductId}:${normalizedCountry}`;

      if (!requestCache.has(cacheKey)) {
        let baseUrl = window.baseUrl;
        if (location.hostname === '127.0.0.1') {
          baseUrl = 'https://marketplace-api-dev.navimow.com';
        }

        const request = window.NW
          .request(
            `${baseUrl}/newOfficialWebsite/product/collection/config`,
            {
              method: 'POST',
              headers: { 'X-Site-Code': window.site },
              body: {
                productCollectionId: [normalizedProductId],
                country: normalizedCountry
              },
            },
          )
          .then((response) => {
            if (
              !response ||
              ![0, 200].includes(Number(response.code)) ||
              !response.data?.productCollections?.[0]
            ) {
              throw new Error(SERVER_ERROR_MESSAGE);
            }
            return response;
          })
          .catch(() => {
            requestCache.delete(cacheKey);
            throw new Error(SERVER_ERROR_MESSAGE);
          });

        requestCache.set(cacheKey, request);
      }

      return requestCache.get(cacheKey);
    };

    const normalizeResponse = (response) => {
      if (!response || ![0, 200].includes(Number(response.code))) {
        throw new Error(SERVER_ERROR_MESSAGE);
      }

      const collection = response.data?.productCollections?.[0];
      if (!collection) throw new Error(SERVER_ERROR_MESSAGE);

      return {
        collection,
        products: Array.isArray(response.data.products) ? response.data.products : [],
        items: Array.isArray(collection.items)
          ? collection.items.map((item) => ({
              ...item,
              productList: Array.isArray(item.productList) ? item.productList : [],
            }))
          : [],
      };
    };

    const buttonStyleClasses = (style) =>
      ({
        primary:
          'border border-transparent bg-[#ff5a00] text-white hover:bg-[#ff6b1a] active:bg-[#e55100]',
        secondary:
          'border border-transparent bg-black/[0.04] text-black/[0.88] hover:bg-black/[0.08] active:bg-black/[0.16]',
        outline:
          'border border-[#ff5a00] bg-transparent text-[#ff5a00] hover:bg-[#ff5a00] hover:text-white',
        'outline-black':
          'border border-black/[0.88] bg-transparent text-black hover:bg-black hover:text-white',
        ghost:
          'border border-transparent bg-transparent text-black/[0.88] hover:bg-black/[0.04]',
      }[style] || 'border border-transparent bg-[#ff5a00] text-white');

    const productUrl = (product) => {
      const fallback = product.handle
        ? `/products/${encodeURIComponent(product.handle)}`
        : '#';
      return safeUrl(product.productUrl, fallback);
    };

    const isAvailable = (product) =>
      Number(product.stock) > 0 ||
      String(product.inventoryPolicy).toUpperCase() !== 'DENY';

    const applyDataTemplate = (template, data) => {
      const value = String(data || '').trim();
      const text = String(template || '').trim();
      if (!text) return value;
      if (/\{\s*data\s*\}/i.test(text)) {
        return text.replace(/\{\s*data\s*\}/gi, value);
      }
      return `${text} ${value}`.trim();
    };

    const renderButton = (settings, product, position) => {
      const button = settings.buttons[position];
      if (!button || button.function === 'none' || !button.text) return '';

      const baseClasses = `flex [transform:translateZ(0)] md:flex-1 h-[40px] min-w-0 items-center justify-center rounded-full border-solid px-[16px] text-center text-[16px] font-semibold leading-[1.25] tracking-[-0.16px] transition-colors max-md:w-full ${buttonStyleClasses(
        button.style,
      )}`;
      if (button.function === 'learn_more') {
        return `<a class="${baseClasses}" href="${escapeHtml(
          safeUrl(button.link, productUrl(product)),
        )}" data-product-action="learn_more" data-button-position="${position + 1}">${escapeHtml(button.text)}</a>`;
      }

      const variantId = variantIdFromGid(product.productId);
      const unavailable = !variantId || !isAvailable(product);
      return `<button class="${baseClasses} disabled:cursor-not-allowed disabled:opacity-40" data-product-action="${escapeHtml(
        button.function,
      )}" data-button-position="${position + 1}" data-variant-id="${escapeHtml(variantId)}"${
        unavailable ? ' disabled aria-disabled="true"' : ''
      }>${escapeHtml(button.text)}</button>`;
    };

    const saleBadgeText = (settings, product) => {
      if (settings.saleBadgeType === 'none') return '';
      if (settings.saleBadgeType === 'price') {
        return product.savePrice
          ? applyDataTemplate(settings.saleBadgePercentageText, product.savePrice)
          : '';
      }
      const percentage = String(product.savePricePercent || '')
        .replace(/\s*off\s*$/i, '')
        .trim();
      return percentage
        ? applyDataTemplate(settings.saleBadgePercentageText, percentage)
        : '';
    };

    const saveTagText = (settings, product) => {
      if (settings.saveTagType === 'none') return '';
      const amount =
        settings.saveTagType === 'percentage'
          ? String(product.savePricePercent || '')
              .replace(/\s*off\s*$/i, '')
              .trim()
          : product.savePrice;
      return amount ? applyDataTemplate(settings.saveTagText, amount) : '';
    };

    const renderInstallment = (settings, product) => {
      if (settings.installmentPaymentType === 'none') return '';

      const amount = priceToMinorUnits(product.price);
      if (!amount) return '';

      const placeholder =
        '<div class="block h-[18px] animate-pulse rounded-[4px] bg-gray-100"></div>';

      if (settings.installmentPaymentType === 'klarna') {
        return `<klarna-placement class="product-card-tiling-placement product-card-tiling__klarna  text-[14px] klarna-placement block min-h-[18px] leading-[18px]" data-key="credit-promotion-auto-size" data-locale="${escapeHtml(
          settings.paymentLocale,
        )}" data-purchase-amount="${amount}">${placeholder}</klarna-placement>`;
      }

      return `<affirm-placement class="product-card-tiling-placement text-[14px] affirm-placement block min-h-[18px] leading-[18px]" amount="${amount}" public-api-key="0277OVZ2CJBZ3VST">${placeholder}</affirm-placement>`;
    };

    const renderCard = (settings, product) => {
      const image = safeUrl(
        Array.isArray(product.image) ? product.image[0] : product.image,
        '',
      );
      const badgeText = saleBadgeText(settings, product);
      const saveText = saveTagText(settings, product);
      const badgeBackground = safeUrl(settings.saleBadgeIcon, '');
      const badgeBackgroundStyle = badgeBackground
        ? ` style="background-image: url('${escapeHtml(badgeBackground)}')"`
        : '';
      const actions = [
        renderButton(settings, product, 0),
        renderButton(settings, product, 1),
      ]
        .filter(Boolean)
        .join('');

      return `
        <article class="product-card-tiling__card flex min-w-0 flex-col overflow-hidden rounded-[16px] bg-white" data-item-id="${escapeHtml(
          product.itemId || '',
        )}" data-product-title="${escapeHtml(product.title || '')}" data-product-price="${escapeHtml(product.price || '')}">
          <a class="product-card-tiling__card-media relative block w-full shrink-0 overflow-hidden" href="${escapeHtml(
            productUrl(product),
          )}" aria-label="${escapeHtml(product.title || 'View product')}">
            ${
              image
                ? `<img class="h-full w-full object-cover" src="${escapeHtml(
                    image,
                  )}" alt="${escapeHtml(
                    product.title || '',
                  )}" width="592" height="320" loading="lazy">`
                : '<span class="flex h-full w-full items-center justify-center text-[14px] text-black/[0.44]">Product image</span>'
            }
            ${
              badgeText
                ? `<span class="product-card-tiling__sale-badge absolute left-0 top-[16px] flex h-[40px] items-center py-[8px] pl-[8px] pr-[24px] text-[14px] font-semibold leading-[1.25] tracking-[-0.14px]"${badgeBackgroundStyle}>${escapeHtml(
                    badgeText,
                  )}</span>`
                : ''
            }
          </a>
          <div class="product-card-tiling__card-content flex flex-1 flex-col items-start [transform:translateZ(0)]">
            <div class="w-full">
              <h3 class="product-card-tiling__card-title font-semibold tracking-[-0.4px] text-black/[0.88]">
                <a class="hover:underline" href="${escapeHtml(
                  productUrl(product),
                )}">${escapeHtml(product.title || '')}</a>
              </h3>
              ${
                product.sellingPoints && product.sellingPoints.length > 0
                  ? `<p class="mt-[8px] line-clamp-2 text-[14px] font-semibold leading-[1.5] tracking-[-0.14px] text-[#8c8c8c] max-md:text-[12px] max-md:tracking-[-0.12px]">${escapeHtml(
                      product.sellingPoints.join(''),
                    )}</p>`
                  : ''
              }
            </div>
            <div class="product-card-tiling__card-main w-full flex-1 flex flex-col">
              <div class="flex min-h-[24px] flex-wrap items-center gap-[8px]">
                <span class="product-card-tiling__price whitespace-nowrap font-semibold leading-none tracking-[-0.48px] text-[#ff4335]">${escapeHtml(
                  product.price || '',
                )}</span>
                ${
                  product.originalPrice
                    ? `<span class="whitespace-nowrap text-[16px] font-normal leading-none text-[#8c8c8c] line-through">${escapeHtml(
                        product.originalPrice,
                      )}</span>`
                    : ''
                }
                ${
                  saveText
                    ? `<span class="inline-flex h-[24px] items-center whitespace-nowrap rounded-[4px] bg-[#ff5a00] px-[8px] py-[4px] text-[14px] font-normal leading-[1.25] tracking-[-0.14px] text-white">${escapeHtml(
                        saveText,
                      )}</span>`
                    : ''
                }
              </div>
              <div class="flex flex-col w-full product-card-tiling__action-inner">
                ${renderInstallment(settings, product)}
                ${
                  actions
                    ? `<div class="product-card-tiling__actions flex w-full gap-[8px]">${actions}</div>`
                    : ''
                }
              </div>
            </div>
          </div>
        </article>`;
    };

    const getSettings = (sectionElement) => ({
      productId: sectionElement.dataset.productId,
      country: sectionElement.dataset.country || 'US',
      showAllTab: sectionElement.dataset.showAllTab === 'true',
      saleBadgeType: sectionElement.dataset.saleBadgeType || 'none',
      saleBadgePercentageText:
        sectionElement.dataset.saleBadgePercentageText || '{data} OFF',
      saleBadgeIcon: sectionElement.dataset.saleBadgeIcon || '',
      saveTagType: sectionElement.dataset.saveTagType || 'none',
      saveTagText: sectionElement.dataset.saveTagText || 'Save',
      installmentPaymentType:
        sectionElement.dataset.installmentPaymentType || 'none',
      paymentLocale: sectionElement.dataset.paymentLocale || 'en-US',
      buttons: [1, 2].map((number) => ({
        function:
          sectionElement.getAttribute(`data-button-0${number}-function`) ||
          'none',
        style:
          sectionElement.getAttribute(`data-button-0${number}-style`) ||
          'primary',
        text: sectionElement.getAttribute(`data-button-0${number}-text`) || '',
        link: sectionElement.getAttribute(`data-button-0${number}-link`) || '',
      })),
    });

    const updateTabScrollControls = (sectionElement) => {
      const tabList = sectionElement.querySelector('[data-product-tabs]');
      const previousButton = sectionElement.querySelector(
        '[data-tab-scroll="previous"]',
      );
      const nextButton = sectionElement.querySelector(
        '[data-tab-scroll="next"]',
      );
      if (!tabList || !previousButton || !nextButton) return;

      const maxScrollLeft = Math.max(
        0,
        tabList.scrollWidth - tabList.clientWidth,
      );
      previousButton.dataset.visible = String(tabList.scrollLeft > 2);
      nextButton.dataset.visible = String(
        maxScrollLeft > 2 && tabList.scrollLeft < maxScrollLeft - 2,
      );
    };

    const revealActiveTab = (tab) => {
      if (!window.matchMedia('(max-width: 768px)').matches) return;

      const tabList = tab.closest('[data-product-tabs]');
      if (!tabList) return;

      const tabRect = tab.getBoundingClientRect();
      const tabListRect = tabList.getBoundingClientRect();
      const distanceToCenter =
        tabRect.left -
        tabListRect.left -
        (tabListRect.width - tabRect.width) / 2;

      tabList.scrollBy({ left: distanceToCenter, behavior: 'smooth' });
    };

    const setActiveTab = (sectionElement, itemId) => {
      sectionElement.querySelectorAll('[data-tab-item-id]').forEach((tab) => {
        const active = tab.dataset.tabItemId === itemId;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        tab.classList.toggle('bg-[#ff5a00]', active);
        tab.classList.toggle('text-white', active);
        tab.classList.toggle('text-black/[0.88]', !active);
        if (active)
          sectionElement
            .querySelector('[data-product-list]')
            ?.setAttribute('aria-labelledby', tab.id);
      });
    };

    const renderProducts = (
      sectionElement,
      settings,
      data,
      itemId = '',
    ) => {
      const list = sectionElement.querySelector('[data-product-list]');
      const status = sectionElement.querySelector('[data-product-status]');
      const visibleProducts = itemId
        ? data.items.find((item) => String(item.itemId) === itemId)?.productList || []
        : data.products;

      list.innerHTML = visibleProducts
        .map((product) => renderCard(settings, product))
        .join('');
      list.scrollLeft = 0;
      list.setAttribute('aria-busy', 'false');
      status.classList.toggle('hidden', visibleProducts.length > 0);
      status.textContent = visibleProducts.length
        ? ''
        : 'No products are available in this category.';
    };

    const renderTabs = (sectionElement, settings, data) => {
      const tabList = sectionElement.querySelector('[data-product-tabs]');
      const tabListWrapper = sectionElement.querySelector(
        '[data-product-tabs-wrapper]',
      );
      const productList = sectionElement.querySelector('[data-product-list]');
      const tabs = [];

      if (data.items.length <= 1) {
        tabList.innerHTML = '';
        tabListWrapper.hidden = true;
        sectionElement
          .querySelectorAll('[data-tab-scroll]')
          .forEach((button) => (button.dataset.visible = 'false'));
        productList?.removeAttribute('aria-labelledby');
        return data.items[0] ? String(data.items[0].itemId) : '';
      }

      tabListWrapper.hidden = false;

      if (settings.showAllTab) {
        tabs.push({ itemId: '', name: 'All', mobileName: 'All Models' });
      }
      data.items.forEach((item) =>
        tabs.push({ itemId: String(item.itemId), name: item.name }),
      );

      tabList.innerHTML = tabs
        .map(
          (tab, index) => `
        <button
          id="${escapeHtml(sectionElement.id)}-tab-${index}"
          class="flex h-[64px] shrink-0 items-center justify-center [transform:translateZ(0)] rounded-full px-[32px] text-[21.33px] font-semibold leading-[1.25] tracking-[-0.2133px] transition-colors max-md:h-[48px] max-md:px-[24px] max-md:text-[16px] max-md:tracking-[-0.16px] ${
            index === 0 ? 'bg-[#ff5a00] text-white' : 'text-black/[0.88]'
          }"
          role="tab"
          aria-controls="${escapeHtml(sectionElement.id)}-products"
          aria-selected="${index === 0}"
          tabindex="${index === 0 ? '0' : '-1'}"
          data-tab-item-id="${escapeHtml(tab.itemId)}"
        >${
          tab.mobileName
            ? `<span class="max-md:hidden">${escapeHtml(
                tab.name,
              )}</span><span class="hidden max-md:inline">${escapeHtml(
                tab.mobileName,
              )}</span>`
            : escapeHtml(tab.name || '')
        }</button>`,
        )
        .join('');

      if (tabs.length) {
        productList?.setAttribute(
          'aria-labelledby',
          `${sectionElement.id}-tab-0`,
        );
      }

      tabList.scrollLeft = 0;
      requestAnimationFrame(() => updateTabScrollControls(sectionElement));

      return tabs[0]?.itemId || '';
    };

    const addToCart = async (sectionElement, button, variantId) => {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      try {
        let sections = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:bundled-sections', {
            bubbles: true,
            detail: { sections },
          }),
        );

        const cartAddUrl =
          window.theme?.routes?.cart_add_url ||
          `${window.Shopify?.routes?.root || '/'}cart/add.js`;
        const fetchConfig = window.theme?.utils?.fetchConfig?.(
          'javascript',
        ) || {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
          },
        };
        const response = await fetch(cartAddUrl, {
          ...fetchConfig,
          headers: {
            ...fetchConfig.headers,
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections,
            sections_url: window.location.pathname,
          }),
        });
        const responseText = await response.text();
        let result;

        try {
          result = responseText ? JSON.parse(responseText) : {};
        } catch {
          throw new Error('Unable to add this product.');
        }

        if (!response.ok || result.status)
          throw new Error(
            result.description ||
              result.message ||
              'Unable to add this product.',
          );

        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', { detail: { product: result } }),
        );
        document.dispatchEvent(
          new CustomEvent('cart-refresh-force', { bubbles: true }),
        );
        document.querySelector('cart-drawer')?.show(button);
      } catch (error) {
        const status = sectionElement.querySelector('[data-product-status]');
        status.textContent = error.message;
        status.classList.remove('hidden');
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    };

    const visibleElementText = (element) => {
      if (!element) return '';
      const visibleChild = [...element.children].find(
        (child) => window.getComputedStyle(child).display !== 'none',
      );
      return (visibleChild || element).textContent.trim();
    };

    const trackProductAction = (sectionElement, actionButton) => {
      const action = actionButton.dataset.productAction;
      const eventName = {
        buy_now: 'Product card tiling-bin',
        add_to_cart: 'Product card tiling-atc',
        learn_more: 'Product card tiling-learn more',
      }[action];
      if (!eventName) return;

      const card = actionButton.closest('.product-card-tiling__card');
      const activeTab = sectionElement.querySelector(
        '[data-tab-item-id][aria-selected="true"]',
      );
      const buttonPosition = actionButton.dataset.buttonPosition || '';
      const eventParameters = {
        current_page: window.location.href,
        heading:
          sectionElement
            .querySelector('.product-card-tiling__title')
            ?.textContent.trim() || '',
        title: visibleElementText(activeTab),
        product_title: card?.dataset.productTitle || '',
        price_: card?.dataset.productPrice || '',
        button_name: `${buttonPosition}_${actionButton.textContent.trim()}`,
      };

      if (action === 'learn_more') {
        eventParameters.link = new URL(
          actionButton.getAttribute('href') || '',
          window.location.href,
        ).href;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: eventName,
        event_parameters: eventParameters,
      });
    };

    const bindEvents = (sectionElement, settings, data) => {
      const tabList = sectionElement.querySelector('[data-product-tabs]');
      tabList.addEventListener(
        'scroll',
        () => updateTabScrollControls(sectionElement),
        { passive: true },
      );
      const tabResizeObserver = new ResizeObserver(() =>
        updateTabScrollControls(sectionElement),
      );
      tabResizeObserver.observe(tabList);

      sectionElement.addEventListener('click', (event) => {
        const tabScrollButton = event.target.closest('[data-tab-scroll]');
        if (tabScrollButton) {
          const direction =
            tabScrollButton.dataset.tabScroll === 'next' ? 1 : -1;
          tabList.scrollBy({
            left: direction * Math.max(120, tabList.clientWidth * 0.75),
            behavior: 'smooth',
          });
          return;
        }

        const tab = event.target.closest('[data-tab-item-id]');
        if (tab) {
          const itemId = tab.dataset.tabItemId || '';
          setActiveTab(sectionElement, itemId);
          revealActiveTab(tab);
          renderProducts(sectionElement, settings, data, itemId);
          return;
        }

        const actionButton = event.target.closest('[data-product-action]');
        if (!actionButton || actionButton.disabled) return;
        trackProductAction(sectionElement, actionButton);

        if (actionButton.dataset.productAction === 'learn_more') return;

        const variantId = actionButton.dataset.variantId;
        if (!variantId) return;

        if (actionButton.dataset.productAction === 'buy_now') {
          const cartUrl =
            window.theme?.routes?.cart_url ||
            `${window.Shopify?.routes?.root || '/'}cart`;
          window.location.href = `${cartUrl}/${variantId}:1?checkout`;
          return;
        }

        addToCart(sectionElement, actionButton, variantId);
      });

      sectionElement.addEventListener('keydown', (event) => {
        const activeTab = event.target.closest('[data-tab-item-id]');
        if (
          !activeTab ||
          !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)
        )
          return;

        const tabs = [...sectionElement.querySelectorAll('[data-tab-item-id]')];
        const currentIndex = tabs.indexOf(activeTab);
        let nextIndex = currentIndex;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (event.key === 'ArrowLeft')
          nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight')
          nextIndex = (currentIndex + 1) % tabs.length;

        event.preventDefault();
        tabs[nextIndex]?.focus();
        tabs[nextIndex]?.click();
      });
    };

    const initSection = async (sectionElement) => {
      if (sectionElement.dataset.initialized === 'true') return;
      sectionElement.dataset.initialized = 'true';

      const settings = getSettings(sectionElement);
      const list = sectionElement.querySelector('[data-product-list]');
      const status = sectionElement.querySelector('[data-product-status]');

      try {
        const response = await getCollectionData(
          settings.productId,
          settings.country,
        );
        const data = normalizeResponse(response);
        const initialItemId = renderTabs(sectionElement, settings, data);
        renderProducts(sectionElement, settings, data, initialItemId);
        bindEvents(sectionElement, settings, data);
      } catch (error) {
        list.innerHTML = '';
        list.setAttribute('aria-busy', 'false');
        status.textContent = error.message;
        status.classList.remove('hidden');
      }
    };

    const initSections = (root = document) => {
      if(!root) return;
      root.querySelectorAll('[data-product-card-tiling]').forEach(initSection);
    };

    initSections();
    document.addEventListener('shopify:section:load', (event) =>
      initSections(event.target),
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich_text-2609"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanups = new Map();
    const getVideos = (videoBlock) => Array.from(videoBlock.querySelectorAll('video'));

    const getActiveVideo = (videoBlock) => {
      const mobileVideo = videoBlock.querySelector('.rich-text-2609__video--mb');
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      return isMobile && mobileVideo
        ? mobileVideo
        : videoBlock.querySelector('.rich-text-2609__video--pc');
    };

    const pauseVideos = (videoBlock) => {
      getVideos(videoBlock).forEach((video) => video.pause());
    };

    const playActiveVideo = (videoBlock) => {
      const video = getActiveVideo(videoBlock);
      if (!video) return;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    const syncPlayToggle = (videoBlock) => {
      const toggle = videoBlock.querySelector('[data-video-play-toggle]');
      const video = getActiveVideo(videoBlock);
      if (!toggle || !video) return;
      const isPlaying = !video.paused && !video.ended;
      toggle.hidden = video.controls && isPlaying;
      toggle.classList.toggle('active', isPlaying);
      toggle.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
    };

    const initializeVideoBlocks = (root) => {
      const blocks = [];
      if (root.matches?.('[data-rich-text-2609-video]')) blocks.push(root);
      blocks.push(...root.querySelectorAll('[data-rich-text-2609-video]'));

      blocks.forEach((videoBlock) => {
        if (videoBlock.dataset.videoInitialized === 'true') return;
        videoBlock.dataset.videoInitialized = 'true';
        const disposeCallbacks = [];
        cleanups.set(videoBlock, () => {
          disposeCallbacks.forEach((dispose) => dispose());
          pauseVideos(videoBlock);
          delete videoBlock.dataset.videoInitialized;
          cleanups.delete(videoBlock);
        });

        getVideos(videoBlock).forEach((video) => {
          video.addEventListener('play', () => syncPlayToggle(videoBlock));
          video.addEventListener('pause', () => syncPlayToggle(videoBlock));
          video.addEventListener('ended', () => syncPlayToggle(videoBlock));
        });

        const playMode = videoBlock.dataset.playMode;
        if (playMode === 'auto' && 'IntersectionObserver' in window) {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  playActiveVideo(videoBlock);
                } else {
                  pauseVideos(videoBlock);
                }
              });
            },
            { threshold: 0.2 }
          );
          observer.observe(videoBlock);
          disposeCallbacks.push(() => observer.disconnect());
        }

        if (playMode === 'hover') {
          videoBlock.addEventListener('mouseenter', () => playActiveVideo(videoBlock));
          videoBlock.addEventListener('mouseleave', () => pauseVideos(videoBlock));
        }

        if (playMode === 'click') {
          const toggle = videoBlock.querySelector('[data-video-play-toggle]');
          toggle?.addEventListener('click', (event) => {
            event.preventDefault();
            const video = getActiveVideo(videoBlock);
            if (!video) return;
            if (video.paused) {
              playActiveVideo(videoBlock);
            } else {
              pauseVideos(videoBlock);
            }
          });
          syncPlayToggle(videoBlock);
        }
      });
    };

    const initialize = () => initializeVideoBlocks(document);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
    document.addEventListener('shopify:section:load', (event) => initializeVideoBlocks(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-rich-text-2609-video]').forEach((videoBlock) => {
        cleanups.get(videoBlock)?.();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-text-enlargement-effect-2609"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new Map();

    const initialize = (section) => {
      if (instances.has(section)) return;

      const { animate, scroll } = window.MotionLatest;
      const intro = section.querySelector('.video-text-enlargement-effect-2609__intro');
      const text = section.querySelector('.video-text-enlargement-effect-2609__text');
      const outro = section.querySelector('.video-text-enlargement-effect-2609__outro');
      const stage = section.querySelector('.video-text-enlargement-effect-2609__stage');
      const videos = Array.from(section.querySelectorAll('[data-enlargement-video]'));
      const mobile = window.matchMedia('(max-width: 767px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const createTextAnimation = () => animate(text, {
        transform: ['scale(1)', `scale(${reducedMotion.matches ? 1 : mobile.matches ? 2.5 : 4})`],
      }, { duration: 1, ease: 'linear', autoplay: false });
      let textAnimation = createTextAnimation();
      const introAnimation = animate(intro, { opacity: [1, 1, 0] }, {
        duration: 1,
        times: [0, 0.08, 1],
        ease: 'linear',
        autoplay: false,
      });
      let currentProgress = 0;
      let inView = false;
      let nearViewport = false;
      let revealed = false;
      let playingVideo = null;
      let disposed = false;

      const preloadActiveVideo = () => {
        const device = mobile.matches ? 'mb' : 'pc';
        const video = videos.find((item) => item.dataset.enlargementVideo === device);
        if (!video || video.preload === 'auto') return;

        video.preload = 'auto';
        video.load();
      };

      const updatePlayback = () => {
        if (inView || nearViewport) preloadActiveVideo();
        const device = mobile.matches ? 'mb' : 'pc';
        const nextVideo = inView && revealed && !document.hidden
          ? videos.find((video) => video.dataset.enlargementVideo === device)
          : null;

        videos.forEach((video) => {
          if (video !== nextVideo) video.pause();
        });
        if (nextVideo === playingVideo) return;
        playingVideo = nextVideo;
        if (!nextVideo) return;

        nextVideo.muted = true;
        nextVideo.currentTime = 0;
        const playRequest = nextVideo.play();
        if (playRequest) {
          playRequest.then(() => {
            if (disposed || playingVideo !== nextVideo) nextVideo.pause();
          }).catch(() => {
            if (playingVideo === nextVideo) playingVideo = null;
          });
        }
      };

      const render = (value) => {
        const current = Math.max(0, Math.min(1, value));
        // Finish the text transition before the separately configured video hold.
        const textProgress = mobile.matches ? current : Math.min(1, current / 0.65);
        const fade = Math.max(0, Math.min(1, (textProgress - 0.08) / 0.92));
        textAnimation.time = textProgress;
        introAnimation.time = textProgress;
        intro.style.pointerEvents = fade >= 0.99 ? 'none' : '';
        // Reveal the second copy only once the intro has completely uncovered the video.
        const showOutro = textProgress >= 1;
        if (outro) {
          outro.classList.toggle('is-visible', showOutro);
          outro.inert = !showOutro;
          outro.setAttribute('aria-hidden', String(!showOutro));
        }
        const nextRevealed = fade >= 0.5;
        if (nextRevealed !== revealed) {
          revealed = nextRevealed;
          updatePlayback();
        }
      };

      // Use scroll info so the returned cleanup also removes target measurements.
      const stopScroll = scroll((_progress, info) => {
        currentProgress = info.y.progress;
        render(currentProgress);
      }, { target: section, offset: ['start start', `${section.dataset.textScrollVh}vh start`] });

      const observer = new IntersectionObserver(([entry]) => {
        inView = entry.isIntersecting;
        updatePlayback();
      });
      observer.observe(stage);

      // Prepare only the active device's video one viewport before it becomes visible.
      const preloadObserver = new IntersectionObserver(([entry]) => {
        nearViewport = entry.isIntersecting;
        if (nearViewport) preloadActiveVideo();
      }, { rootMargin: `${window.innerHeight}px 0px` });
      preloadObserver.observe(stage);

      const updateMotionPreference = () => {
        textAnimation.stop();
        textAnimation = createTextAnimation();
        render(currentProgress);
      };
      const updateDevice = () => {
        updateMotionPreference();
        updatePlayback();
      };
      mobile.addEventListener('change', updateDevice);
      reducedMotion.addEventListener('change', updateMotionPreference);
      document.addEventListener('visibilitychange', updatePlayback);

      instances.set(section, () => {
        disposed = true;
        stopScroll();
        textAnimation.stop();
        introAnimation.stop();
        observer.disconnect();
        preloadObserver.disconnect();
        mobile.removeEventListener('change', updateDevice);
        reducedMotion.removeEventListener('change', updateMotionPreference);
        document.removeEventListener('visibilitychange', updatePlayback);
        videos.forEach((video) => video.pause());
        instances.delete(section);
      });
    };

    const initializeSections = (root) => {
      root.querySelectorAll('[data-video-text-enlargement-effect-2609]').forEach(initialize);
    };

    document.addEventListener('DOMContentLoaded', () => initializeSections(document));
    document.addEventListener('shopify:section:load', (event) => initializeSections(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-video-text-enlargement-effect-2609]').forEach((section) => {
        instances.get(section)?.();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video_text_shrink_effect-2609"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new Map();
    const selector = '[data-video-text-shrink]';

    function initialize(root) {
      if (instances.has(root)) return;

      const { scroll, transform, springValue } = window.MotionLatest;
      const stage = root.querySelector('[data-stage]');
      const video = root.querySelector('[data-video]');
      const media = root.querySelector('[data-media]');
      const cutout = root.querySelector('[data-cutout]');
      const maskText = root.querySelector('[data-mask-text]');
      const heading = root.querySelector('[data-heading]');
      const final = root.querySelector('[data-final]');
      const subheading = root.querySelector('[data-subheading]');
      const emphasized = root.querySelector('[data-emphasized]');
      const mobile = matchMedia('(max-width: 767px)');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      // Scale and crossfade share scroll progress so the title layers stay aligned.
      const progressSpring = springValue(0, {
        stiffness: 180,
        damping: 30,
        mass: 1,
        restDelta: 0.0001,
        restSpeed: 0.001,
      });
      // Once triggered, the supporting copy finishes independently of scrolling.
      const detailsSpring = springValue(0, {
        stiffness: 100,
        damping: 24,
        mass: 1,
        restDelta: 0.0001,
        restSpeed: 0.001,
      });
      let stopScroll;
      let disposed = false;
      let inView = false;
      let travel = 0;
      let centerX = 0;
      let centerY = 0;
      let stageHeight = 0;
      let emphasizedEnd = 0;
      let detailsShown = false;

      function renderDetails() {
        const amount = detailsSpring.get();
        if (subheading) {
          subheading.style.opacity = amount;
          subheading.style.transform = `translateY(${(1 - amount) * 16}px)`;
        }
        if (emphasized) {
          emphasized.style.top = `${stageHeight * 0.855}px`;
          const offset = (emphasizedEnd - stageHeight * 0.855) * amount;
          emphasized.style.transform = `translate(-50%, -50%) translateY(${offset}px)`;
        }
      }

      function updatePlayback() {
        const shouldPlay = inView && !document.hidden && !reducedMotion.matches && travel < 1.2;
        if (shouldPlay && video.querySelector('source')) {
          if (video.paused) video.play().catch(() => {});
        } else {
          video.pause();
        }
      }

      function selectVideo() {
        const template = root.querySelector(mobile.matches ? '[data-video-mobile]' : '[data-video-desktop]');
        video.pause();
        video.replaceChildren(template.content.cloneNode(true));
        video.muted = true;
        video.load();
        updatePlayback();
      }

      function render() {
        const position = reducedMotion.matches ? 1.4 : travel;
        // Finish scaling before revealing the gradient: both text layers stay at 1x
        // throughout the crossfade, so their glyphs do not drift apart.
        const scale = transform(position, [0, 0.8, 1], [6.5, 1.2, 1]);
        const finish = transform(position, [1, 1.2], [0, 1]);
        cutout.style.opacity = transform(position, [0, 0.12], [0, 1]);
        maskText.setAttribute('transform', `translate(${centerX} ${centerY}) scale(${scale}) translate(${-centerX} ${-centerY})`);
        final.style.opacity = finish;
        heading.style.opacity = finish;
        const showDetails = position >= 1;
        if (reducedMotion.matches) {
          detailsShown = true;
          detailsSpring.jump(1);
        } else if (showDetails !== detailsShown) {
          detailsShown = showDetails;
          detailsSpring.set(showDetails ? 1 : 0);
        }
        media.style.visibility = position >= 1.2 ? 'hidden' : 'visible';
        updatePlayback();
      }

      function measure() {
        if (disposed) return;
        const bounds = stage.getBoundingClientRect();
        const headingBounds = heading.getBoundingClientRect();
        const style = getComputedStyle(heading);
        stageHeight = bounds.height;
        centerX = headingBounds.left - bounds.left + headingBounds.width / 2;
        centerY = headingBounds.top - bounds.top + headingBounds.height / 2;
        cutout.setAttribute('viewBox', `0 0 ${bounds.width} ${bounds.height}`);

        // Read browser wrapping, including explicit line breaks and CJK text.
        // This runs on resize/font load, never inside the scroll callback.
        const lines = [];
        const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
        const range = document.createRange();
        let node;
        while ((node = walker.nextNode())) {
          let offset = 0;
          for (const character of node.textContent) {
            range.setStart(node, offset);
            offset += character.length;
            range.setEnd(node, offset);
            const rect = range.getBoundingClientRect();
            if (!rect.height) continue;
            let line = lines.find((item) => Math.abs(item.top - rect.top) < 2);
            if (!line) {
              line = { top: rect.top, left: Infinity, text: '' };
              lines.push(line);
            }
            line.text += character;
            if (character.trim()) line.left = Math.min(line.left, rect.left);
          }
        }
        maskText.replaceChildren();
        lines.forEach((line) => {
          if (!line.text.trim()) return;
          const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
          text.setAttribute('x', line.left - bounds.left);
          text.setAttribute('y', '0');
          text.style.fontFamily = style.fontFamily;
          text.style.fontSize = style.fontSize;
          text.style.fontWeight = style.fontWeight;
          text.style.letterSpacing = style.letterSpacing;
          text.textContent = line.text.trim();
          maskText.append(text);
          // SVG's central baseline differs from HTML's line box. Match the
          // measured font box instead, using the HTML line's actual left edge.
          text.setAttribute('y', line.top - bounds.top - text.getBBox().y);
        });

        if (emphasized) {
          // Keep the badge below long merchant-provided titles, too.
          emphasizedEnd = Math.min(
            stageHeight - emphasized.offsetHeight / 2 - 24,
            Math.max(stageHeight * (mobile.matches ? 0.76 : 0.688), headingBounds.bottom - bounds.top + 48 + emphasized.offsetHeight / 2)
          );
        }
        render();
        renderDetails();
      }

      function bindScroll() {
        stopScroll?.();
        progressSpring.stop();
        root.classList.toggle('is-ready', !reducedMotion.matches);
        measure();
        if (!reducedMotion.matches) {
          let firstUpdate = true;
          stopScroll = scroll((progress) => {
            // Hold the initial frame for 50vh after the section reaches the top.
            const position = Math.max(0, progress * 1.9 - 0.5);
            // Restore the right frame immediately on page/editor reload.
            if (firstUpdate) {
              progressSpring.jump(position);
              detailsShown = position >= 1;
              detailsSpring.jump(detailsShown ? 1 : 0);
            } else {
              progressSpring.set(position);
            }
            firstUpdate = false;
          }, { target: root, offset: ['start start', 'end end'] });
        }
      }

      const stopSpring = progressSpring.on('change', (value) => {
        travel = value;
        render();
      });
      const stopDetails = detailsSpring.on('change', renderDetails);
      const observer = new IntersectionObserver(([entry]) => {
        // Observe the one-screen stage, not the taller scrolling section.
        inView = entry.isIntersecting && entry.intersectionRatio >= 0.5;
        updatePlayback();
      }, { threshold: [0, 0.5] });
      const resizeObserver = new ResizeObserver(measure);
      const onBreakpoint = () => { selectVideo(); measure(); };

      selectVideo();
      bindScroll();
      observer.observe(stage);
      resizeObserver.observe(stage);
      resizeObserver.observe(heading);
      document.fonts.ready.then(measure);
      mobile.addEventListener('change', onBreakpoint);
      reducedMotion.addEventListener('change', bindScroll);
      document.addEventListener('visibilitychange', updatePlayback);

      instances.set(root, () => {
        disposed = true;
        stopScroll?.();
        stopSpring();
        progressSpring.destroy();
        stopDetails();
        detailsSpring.destroy();
        observer.disconnect();
        resizeObserver.disconnect();
        mobile.removeEventListener('change', onBreakpoint);
        reducedMotion.removeEventListener('change', bindScroll);
        document.removeEventListener('visibilitychange', updatePlayback);
        video.pause();
        instances.delete(root);
      });
    }

    function initializeWithin(container) {
      container.querySelectorAll(selector).forEach(initialize);
    }

    document.addEventListener('DOMContentLoaded', () => initializeWithin(document));
    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(selector).forEach((root) => instances.get(root)?.());
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
